import React, { useEffect, useRef, useState } from 'react';
import Footer from '../Footer';

export default function LandingFooter() {
  const footerRef = useRef(null);
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  useEffect(() => {
    const target = footerRef.current;
    const observerCallback = ([entry]: IntersectionObserverEntry[]) => {
      setIsFooterVisible(entry.isIntersecting);
    };
    const observerOptions = {
      threshold: 0.1, // 보이는 정도 (10% 이상 보이면 감지)
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    if (target) {
      observer.observe(target);
    }
    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, []);
  useEffect(() => {
    const button = document.getElementById('floating-button');
    if (button) {
      if (isFooterVisible) {
        button.classList.remove('landing-floating-active-btn');
      } else {
        button.classList.add('landing-floating-active-btn');
      }
    }
  }, [isFooterVisible]);
  return (
    <div ref={footerRef}>
      <Footer />
    </div>
  );
}
